module.exports = __webpack_public_path__ + "img/162.68a801ec.jpg";